<mf-page title="Órdenes">
  <mf-order-grid [transferId]="transferId" />
</mf-page>
